export default __webpack_public_path__ + "static/media/3-Cloudxier-DailyCaffeine.cf81b5e0.jpg";